import { useMutation } from '@tanstack/react-query'
import type { LogisticsApiGetPresignedURLLabelRequest } from '@itsrever/rever-api'
import { getPresignedURLLabel } from '@/redux/api/logistics-api'

export const usePresignedURLLabel = () => {
  return useMutation({
    mutationFn: (req: LogisticsApiGetPresignedURLLabelRequest) =>
      getPresignedURLLabel(req)
  })
}
